/**
 * DEFAULT_PAGE_CONTENT — fail-safe copy of the seed content used by the
 * frontend when the /api/public/website-content/{page_key} endpoint is
 * temporarily unavailable. Keep the wording in this file in sync with the
 * backend seed at /app/backend/website_content_defaults.py.
 */
export const DEFAULT_PAGE_CONTENT = {
  home: {
    title: "Barter India — Trade More. Pay Less. Grow Together.",
    content: {
      hero_eyebrow: "B2B BARTER MARKETPLACE",
      hero_headline: "Trade More. Pay Less. Grow Together.",
      hero_supporting:
        "Barter India helps verified businesses exchange products and services using Barter Credits — preserving cash, unlocking idle value and creating new B2B opportunities.",
      primary_cta_text: "Explore Marketplace",
      primary_cta_href: "/login",
      secondary_cta_text: "Register Your Business",
      secondary_cta_href: "/login",

      trust_strip_visible: true,
      trust_strip_items: [
        { title: "Verified Businesses",    description: "KYC-checked before trade." },
        { title: "Barter Credits",         description: "Cash-free settlement unit." },
        { title: "Admin-Assisted Trading", description: "Every trade reviewed by our team." },
        { title: "Transparent Settlement", description: "Immutable ledger and audit trail." },
      ],

      how_it_works_visible: true,
      how_it_works_heading: "How Barter India Works",
      how_it_works_supporting: "Turn what your business has into what your business needs.",
      how_it_works_steps: [
        { title: "Register & Verify",          description: "Create your company profile and complete business verification." },
        { title: "List What You Have",         description: "Offer products, inventory, idle capacity or professional services." },
        { title: "Find What You Need",         description: "Discover approved listings from verified businesses." },
        { title: "Trade with Barter Credits",  description: "Complete approved trades through the Barter India settlement process." },
      ],

      benefits_visible: true,
      benefits_heading: "Put Your Business's Idle Value to Work",
      benefits_supporting: "Barter India helps businesses exchange value without making every transaction dependent on immediate cash payment.",
      benefits_items: [
        { title: "Preserve Working Capital",  description: "Use your business resources while reducing immediate cash outflow." },
        { title: "Unlock Idle Inventory",     description: "Turn excess stock, unused capacity and available services into business value." },
        { title: "Reach New B2B Customers",   description: "Connect with verified businesses looking for products and services like yours." },
        { title: "Trade With Greater Control",description: "Verification, approvals, credit tracking and settlement are built into the platform." },
      ],

      barter_types_visible: true,
      barter_types_heading: "More Than Traditional Barter",
      barter_types_supporting: "Trade directly when two businesses can meet each other's needs — or participate in a circular exchange when they cannot.",
      direct_barter_title: "Direct Barter",
      direct_barter_description: "Business A provides value to Business B and receives value in return.",
      circular_barter_title: "Circular Barter",
      circular_barter_description: "When three businesses can complete a connected exchange, value can move around the network.",

      marketplace_preview_visible: true,
      marketplace_preview_heading: "Discover What Businesses Are Trading",
      marketplace_preview_supporting: "Explore products and services offered by verified businesses across India.",
      marketplace_preview_cta: "Explore Marketplace",

      trust_section_visible: true,
      trust_section_heading: "Built for Businesses. Designed for Trust.",
      trust_section_supporting: "Companies go through verification before participating in trading.",
      trust_section_points: [
        { title: "Business Verification",        description: "PAN, incorporation certificate and address proof are reviewed before a company can trade." },
        { title: "Controlled Trade Approval",    description: "Every trade request is reviewed by Barter India before it activates." },
        { title: "Credit-Based Settlement",      description: "Barter Credits move atomically between accounts on settlement." },
        { title: "Auditable Transaction History",description: "Listings, trade requests, settlements and disputes are all logged." },
      ],

      final_cta_heading: "Turn What Your Business Has Into What Your Business Needs.",
      final_cta_description: "Register your business, complete verification, and start trading with Barter Credits across India's growing B2B network.",
      final_cta_primary_text: "Explore Marketplace",
      final_cta_primary_href: "/login",
      final_cta_secondary_text: "Register Your Business",
      final_cta_secondary_href: "/login",

      // legacy compatibility
      value_proposition: "Direct barter (1-to-1) and 3-party circular barter — A→B→C→A — let your business unlock trades that a two-party marketplace cannot.",
      trust_content: "Barter India is an admin-facilitated platform. Every trade request is reviewed and approved by Barter India before it goes active.",
      final_cta_button: "Register Your Business",
      final_cta_href: "/login",
      footer_description: "Barter India — a verified B2B barter marketplace facilitating trades between Indian businesses using Barter Credits.",
      footer_support: "For any queries write to admin@barterindia.in.",
    },
  },
  pricing: {
    title: "Barter India — Plans & Pricing",
    content: {
      intro:
        "Every Barter India subscription unlocks a Barter Credit facility for your business. Your credit limit is determined by the plan you choose. Barter India also charges a 10% facilitator fee (plus applicable GST) on the value of every successfully settled trade.",
      footer_notes_html: "",
    },
  },
  terms:     { title: "Terms & Conditions",            content: { body_html: "<p>Loading terms…</p>" } },
  privacy:   { title: "Privacy Policy",                 content: { body_html: "<p>Loading privacy policy…</p>" } },
  refund:    { title: "Cancellation & Refund Policy",   content: { body_html: "<p>Loading refund policy…</p>" } },
  shipping:  { title: "Shipping Policy",                content: { body_html: "<p>Loading shipping policy…</p>" } },
  contact:   { title: "Contact Barter India",           content: { body_html: "<p>For support write to <a href='mailto:admin@barterindia.in'>admin@barterindia.in</a>.</p>" } },
  grievance: { title: "Grievance & Support",            content: { body_html: "<p>For grievances write to <a href='mailto:admin@barterindia.in'>admin@barterindia.in</a>.</p>" } },
};
